module.exports = __webpack_public_path__ + "static/media/earth.b99d0d23.webp";